import styled from 'styled-components'

export const EvaluationTextContainer = styled.div`
  margin-right: 1em;
`
